import { Tab } from 'bootstrap';

function initTab() {
    const triggerTabList = document.querySelectorAll('#step-tab .contact__step-button')
    triggerTabList.forEach(triggerEl => {
        const tabTrigger = new Tab(triggerEl)

        // triggerEl.addEventListener('click', event => {
        //     event.preventDefault()
        //     tabTrigger.show()
        // })
    })
}

function validationForm() {
    const nextBtn = document.querySelector('#next-btn')

    nextBtn.addEventListener('click', event => {
        event.preventDefault()

        const step2Btn = document.querySelector('#step-tab .contact__step-button[data-bs-target="#form-step-2"]')
        const tabIns = Tab.getInstance(step2Btn)
        const contactEl = document.querySelector('.contact')
        
        tabIns.show()

        const contactElPos = contactEl.getBoundingClientRect().top + window.pageYOffset - 100;
        window.scrollTo({ 
            top: contactElPos, 
            behavior: 'smooth' 
        });
        
    })

    const prevBtn = document.querySelector('#prev-btn')

    prevBtn.addEventListener('click', event => {
        event.preventDefault()

        const step1Btn = document.querySelector('#step-tab .contact__step-button[data-bs-target="#form-step-1"]')
        const tabIns = Tab.getInstance(step1Btn)
        const contactEl = document.querySelector('.contact')
        
        tabIns.show()

        const contactElPos = contactEl.getBoundingClientRect().top + window.pageYOffset - 100;
        window.scrollTo({ 
            top: contactElPos, 
            behavior: 'smooth' 
        });
        
    })

    const submitBtn = document.querySelector('#submit-btn')
    const cf7submitBtn = document.querySelector('.wpcf7-form-control.wpcf7-submit')

    submitBtn.addEventListener('click', event => {
        event.preventDefault()
        cf7submitBtn.click()

        document.addEventListener('wpcf7mailsent', () => {
            const step3Btn = document.querySelector('#step-tab .contact__step-button[data-bs-target="#form-step-3"]')
            const tabIns = Tab.getInstance(step3Btn)
            const contactEl = document.querySelector('.contact')
            
            tabIns.show()
    
            const contactElPos = contactEl.getBoundingClientRect().top + window.pageYOffset - 100;
            window.scrollTo({ 
                top: contactElPos, 
                behavior: 'smooth' 
            });
        })
        
    })


    const acceptanceCheckbox = document.querySelector('input[type="checkbox"][name="acceptance"]')
    const form = document.querySelector('#form-step-1 .wpcf7-form');
    
    function toggleNextBtnState() {
        setTimeout(() => {
            const isChecked = acceptanceCheckbox.checked;
            const hasErrors = form.querySelector('.wpcf7-not-valid-tip') !== null;
            
            // The button should be ENABLED ONLY if isChecked is true AND hasErrors is false
            if (isChecked && !hasErrors) {
                nextBtn.disabled = false;
            } else {
                nextBtn.disabled = true;
            }
        }, 100);
    }
    
    toggleNextBtnState();

    acceptanceCheckbox.addEventListener('change', toggleNextBtnState);
    form.addEventListener('focusout', toggleNextBtnState);

    // show step 1 tab if there are validation errors
    document.addEventListener('wpcf7invalid', () => {
        const step1Btn = document.querySelector('#step-tab .contact__step-button[data-bs-target="#form-step-1"]')
        const tabIns = Tab.getInstance(step1Btn)

        tabIns.show()

        setTimeout(() => {
            const form = document.querySelector('#form-step-1 .wpcf7-form .wpcf7-not-valid-tip');
            const formElPos = form.getBoundingClientRect().top + window.pageYOffset - 300;
            window.scrollTo({ 
                top: formElPos, 
                behavior: 'smooth' 
            });
        }, 500);
    })
}

function getPostalCode() {
    const btn = document.querySelector('#postal-code-btn')

    btn.addEventListener('click', async (event) => {
        event.preventDefault();
        const postalInput = document.querySelector('#postal-code');
        const prefectureInput = document.querySelector('#address');
        const postalCode = postalInput ? postalInput.value.trim() : '';

        if (!postalCode) return;

        btn.style.cursor = 'wait'

        try {
            const response = await fetch(`https://zipcloud.ibsnet.co.jp/api/search?zipcode=${encodeURIComponent(postalCode)}`);
            const data = await response.json();

            if (data && data.results && data.results.length > 0) {
                const result = data.results[0];
                const prefecture = result.address1 || '';
                const city = result.address2 || '';
                const town = result.address3 || '';
                if (prefectureInput) {
                    prefectureInput.value = `${prefecture}${city}${town}`;
                }
                btn.style.cursor = 'pointer'
            } else {
                if (prefectureInput) {
                    prefectureInput.value = '';
                }
                btn.style.cursor = 'pointer'
                alert('郵便番号が見つかりませんでした。');
            }
        } catch (error) {
            btn.style.cursor = 'pointer'
            alert('郵便番号検索でエラーが発生しました。');
        }
    });
}

function getFormData() {
    const form = document.querySelector('#form-step-1 .wpcf7-form');
    const formData = {};
    const fieldLabels = {};

    function getLabel(element) {
        // Try to find a <label for="...">
        if (element.id) {
            const label = form.querySelector(`label[for="${element.id}"]`);
            if (label) return label.textContent.trim();
        }
        // Try parent label (for radio/checkbox)
        if (element.closest('label')) {
            const row = element.closest('.custom-form__row');
            if (row) {
                const fieldLabel = row.querySelector('.custom-form__label');
                if (fieldLabel) {
                    return fieldLabel.textContent.trim();
                }
            }
            return element.closest('label').textContent.trim();
        }
        // Try previous sibling label
        let prev = element.previousElementSibling;
        while (prev) {
            if (prev.tagName && prev.tagName.toLowerCase() === 'label') {
                return prev.textContent.trim();
            }
            prev = prev.previousElementSibling;
        }
        // Fallback to name
        return element.name;
    }

    if (form) {
        Array.from(form.elements).forEach(element => {
            if (
                element.name &&
                element.name !== 'acceptance' &&
                element.name !== 'email-confirm' &&
                !element.disabled &&
                ['input', 'select', 'textarea'].includes(element.tagName.toLowerCase()) &&
                element.type !== 'hidden'
            ) {
                const label = getLabel(element);
                fieldLabels[element.name] = label;

                if (element.type === 'checkbox') {
                    if (!formData[element.name]) formData[element.name] = [];
                    if (element.checked) formData[element.name].push(element.value);
                } else if (element.type === 'radio') {
                    if (element.checked) formData[element.name] = element.value;
                } else {
                    formData[element.name] = element.value;
                }
            }
        });

        // Listen for focusout (move out) on each field
        Array.from(form.elements).forEach(element => {
            if (
                element.name &&
                element.name !== 'acceptance' &&
                element.name !== 'email-confirm' &&
                !element.disabled &&
                ['input', 'select', 'textarea'].includes(element.tagName.toLowerCase()) &&
                element.type !== 'hidden'
            ) {
                element.addEventListener('focusout', () => {
                    // Update formData for this field
                    if (element.type === 'checkbox') {
                        formData[element.name] = [];
                        Array.from(form.querySelectorAll(`[name="${element.name}"]`)).forEach(cb => {
                            if (cb.checked) formData[element.name].push(cb.value);
                        });
                    } else if (element.type === 'radio') {
                        const checked = form.querySelector(`[name="${element.name}"]:checked`);
                        formData[element.name] = checked ? checked.value : '';
                    } else {
                        formData[element.name] = element.value;
                    }

                    // Print values in second step
                    const secondStep = document.querySelector('#form-step-2');
                    if (secondStep) {
                        // Remove previous summary if exists
                        let summary = secondStep.querySelector('.form-summary');
                        if (summary) summary.remove();

                        summary = document.createElement('div');
                        summary.className = 'custom-form form-summary';
                        summary.innerHTML = Object.entries(formData)
                            .map(([key, value]) => {
                                let label = fieldLabels[key] || key;
                                if (Array.isArray(value)) value = value.join(', ');
                                return `
                                <div class="custom-form__row">
                                    <span class="custom-form__label custom-form__label--bold">${label}</span> 
                                    <span class="custom-form__label">${value}</span>
                                </div>
                                <hr>
                                `;
                            })
                            .join('');
                        secondStep.prepend(summary);
                    }
                });
            }
        });
    }
}

function sendForm() {
    const step2SubmitBtn = document.querySelector('#form-step-2 button[type="submit"]');
    const step1SubmitBtn = document.querySelector('#form-step-1 .wpcf7-form-control.wpcf7-submit');

    if (step2SubmitBtn && step1SubmitBtn) {
        step2SubmitBtn.addEventListener('click', (e) => {
            e.preventDefault();
            step1SubmitBtn.click();
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    initTab()
    validationForm()
    getPostalCode()
    getFormData()
    sendForm()
})